export const smallProductsSliderOptions = (instance, options, maxItems) => {
    let responsiveItemCounts = {
        600: 2,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = Math.min(responsiveItemCounts[resolution], Number(maxItems));

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: 1,
        }
    }

    return {
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        cssMode: false,
        spaceBetween: 8,
        pagination: {
            el: instance.paginationEl,
            type: 'bullets',
            clickable: true,
            dynamicBullets: false,
            dynamicMainBullets: 10,
            hideOnClick: false,
        },
        breakpoints: breakpoints
    }
}